/**
 *
 * @param key string i.e. 'temperatureOk-0'
 * @returns
 */

export const getMultipackItemNumber = (key: string) => {
  return Number(key.split('-')[1]) + 1
}
